import {LIMIT_PER_PAGE} from 'web/constant';
import BaseAPI from 'web/redux/actions/BaseAPI';
import {fetchMachineList} from 'web/redux/actions/MachineActions';
import store from 'web/redux/store';
import enumList from 'web/utils/enumList';
import {showMessage} from 'web/utils/modalHelper';

/**
 *
 */
export default function useMachineAssignment({customerCode, dispatch}) {
  if (!(typeof customerCode === 'string' && typeof dispatch === 'function')) {
    return {};
  }
  const fetchMachines = async ({
    limit = LIMIT_PER_PAGE,
    page = 1,
    machineSerialNumber,
  }) => {
    try {
      const response = await dispatch(
        fetchMachineList({
          withAssignment: 1,
          machineSerialNumber,
          limit,
          page,
          isNeedToOrder: true,
        }),
      );

      if (!response?.payload?.code?.isSuccessCode()) {
        return [];
      }
      return response.payload.result;
    } catch (error) {
      showMessage(
        enumList.messageModalMode.error,
        error?.response?.data?.payload?.message || '發生錯誤',
      );
      throw error;
    }
  };

  const fetchAssignments = async () => {
    try {
      const token = store.getState().auth.token;
      const response = await BaseAPI.getWithAuth(
        `/customer/${customerCode}/machines`,
        {},
        token,
      );

      return response.result;
    } catch (error) {
      showMessage(
        enumList.messageModalMode.error,
        error?.response?.data?.payload?.message || '發生錯誤',
      );
      throw error;
    }
  };

  const assign = async ({
    machineIDs,
    deliveryDate,
    flgIsResold,
    flgOnSiteCheck,
  }) => {
    try {
      const token = store.getState().auth.token;
      const response = await BaseAPI.postWithAuth(
        `/customer/${customerCode}/machines`,
        {
          machineIDs,
          deliveryDate,
          flgIsResold,
          flgOnSiteCheck,
        },
        token,
      );

      return response.result;
    } catch (error) {
      showMessage(
        enumList.messageModalMode.error,
        error?.response?.data?.payload?.message || '發生錯誤',
      );
      throw error;
    }
  };

  const fetchAssignment = async (machineID) => {
    try {
      const token = store.getState().auth.token;
      const response = await BaseAPI.getWithAuth(
        `/customer/${customerCode}/machines/${machineID}`,
        {},
        token,
      );

      return response.result;
    } catch (error) {
      showMessage(
        enumList.messageModalMode.error,
        error?.response?.data?.payload?.message || '發生錯誤',
      );
      throw error;
    }
  };

  const updateAssignment = async (
    machineID,
    {deliveryDate, flgIsResold, flgOnSiteCheck},
  ) => {
    try {
      const token = store.getState().auth.token;
      const response = await BaseAPI.putWithAuth(
        `/customer/${customerCode}/machines/${machineID}`,
        {
          deliveryDate,
          flgIsResold,
          flgOnSiteCheck,
        },
        token,
      );

      return response.result;
    } catch (error) {
      showMessage(
        enumList.messageModalMode.error,
        error?.response?.data?.payload?.message || '發生錯誤',
      );
      throw error;
    }
  };

  const deassign = async (machineIDs) => {
    try {
      const token = store.getState().auth.token;
      const response = await BaseAPI.deleteWithAuth(
        `/customer/${customerCode}/machines`,
        {
          machines: machineIDs.join(','),
        },
        token,
      );

      return response.result;
    } catch (error) {
      showMessage(
        enumList.messageModalMode.error,
        error?.response?.data?.payload?.message || '發生錯誤',
      );
      throw error;
    }
  };
  return {
    fetchMachines,
    fetchAssignments,
    assign,
    fetchAssignment,
    updateAssignment,
    deassign,
  };
}
